export const MODE_SOLUTION = 'solution';
export const MODE_BLANC = 'blanc';
export const MODE_ENTRAINEMENT = 'ent';
export const TYPE_THEMATIQUE = 'theme';
